import { metricKeys } from '@pulse/metrics';

export const commonExcludeMetricList = [
  metricKeys.user_session_with_rage_click,
  metricKeys.user_session_with_rage_click_percentage,
  metricKeys.users_with_rage_click,
  metricKeys.users_with_rage_click_percentage,
  metricKeys.user_session_with_app_restart,
  metricKeys.user_session_with_app_restart_percentage,
  metricKeys.users_with_app_restart,
  metricKeys.users_with_app_restart_percentage,
  metricKeys.user_session_with_page_loop,
  metricKeys.user_session_with_page_loop_percentage,
  metricKeys.users_with_page_loop,
  metricKeys.users_with_page_loop_percentage,
  metricKeys.user_session_with_click_to_error,
  metricKeys.user_session_with_click_to_error_percentage,
  metricKeys.users_with_click_to_error,
  metricKeys.users_with_click_to_error_percentage,
  metricKeys.users_with_app_crash,
  metricKeys.users_with_app_crash_percentage,
  metricKeys.user_session_with_app_crash,
  metricKeys.user_session_with_app_crash_percentage,
  metricKeys.user_session_with_anr,
  metricKeys.user_session_with_anr_percentage,
  metricKeys.users_with_anr,
  metricKeys.users_with_anr_percentage,
  metricKeys.user_session_with_app_crash_v2,
  metricKeys.user_session_with_app_crash_v2_percentage,
  metricKeys.users_with_app_crash_v2,
  metricKeys.users_with_app_crash_v2_percentage,
  metricKeys.unique_users,
  metricKeys.unique_devices,
];

export const exclusiveFrustrationSignalDimension = ['frustration_signal'];
